import { render } from "./SiteNav.vue?vue&type=template&id=b4cfff28&scoped=true"
import script from "./SiteNav.vue?vue&type=script&lang=js"
export * from "./SiteNav.vue?vue&type=script&lang=js"

import "./SiteNav.vue?vue&type=style&index=0&id=b4cfff28&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4cfff28"]])

export default __exports__